import moment from "moment";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import APIS from "../../constant/Endpoint";
import DataTable from "../Reusable/DataTable";
import { classNames } from "../Reusable/DatePicker/helpers";
import TableActionButton from "../Reusable/TableActionButton";
import SwitchButton from "../Reusable/SwitchButton";
import Modal from "../Reusable/Modal";
import { useState } from "react";
import useDeleteHook from "../../customHooks/useDeleteHook";
import TableDeleteButton from "../Reusable/TableDeleteButton";
import Remark from "../Reusable/Remarks/Remark";
import ImageCell from "../Reusable/DataTable/ImageCell";
import { AccessControl } from "@careinfo/permission-required";

const PostList = ({
  handlePublish,
  handlePublic,
  isPatching,
}: {
  handlePublish: Function;
  handlePublic: Function;
  isPatching: boolean;
}) => {
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [selectedId, setSelectedId] = useState("");
  const [selectedRemark, setSelectedRemark] = useState("");
  const [showRemarksModal, setShowRemarksModal] = useState(false);

  const { mutateAsync, isLoading } = useDeleteHook({
    queryKey: ["delete-post"],
    navigateURL: "/blog/post",
  });

  const handleDelete = (id: string) => {
    setSelectedId(id);
    setOpenDeleteModal(true);
  };

  const handleModalClose = () => {
    setOpenDeleteModal(false);
    setSelectedId("");
  };

  const deletePost = async () => {
    const url = `${APIS.BLOG_STATUS}${selectedId}/`;
    try {
      await mutateAsync({ url });
      handleModalClose();
    } catch (error) {
      console.error(error);
    }
  };

  const handleRemarksModalClose = () => {
    setShowRemarksModal(false);
  };

  const defaultColumns: any = [
    {
      header: "Author",
      accessorKey: "author",
      cell: ImageCell,
    },
    {
      header: "Headline",
      accessorKey: "headline",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p className={tw`uppercase`}>{getValue()}</p>
          </>
        );
      },
    },
    {
      header: "Public",
      accessorKey: "is_public",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <SwitchButton
              id={row.original.id}
              value={getValue()}
              onChange={(value: boolean) =>
                handlePublic(value, row.original.id)
              }
              disabled={isPatching}
            />
          </>
        );
      },
    },
    {
      header: "Published",
      accessorKey: "is_published",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <SwitchButton
              id={row.original.id}
              value={getValue()}
              onChange={(value: boolean) =>
                handlePublish(value, row.original.id)
              }
              disabled={isPatching}
            />
          </>
        );
      },
    },
    {
      header: "Views",
      accessorKey: "views_count",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p>
              {getValue() ?? "0"}
              <span className="text-gray-500 text-xs"></span>{" "}
            </p>
          </>
        );
      },
    },
    {
      header: "Remarks",
      accessorKey: "id",
      cell: ({ row, getValue }) => {
        return (
          <button
            className={tw`w-full`}
            onClick={() => {
              setShowRemarksModal(true);
              setSelectedRemark(getValue());
            }}
          >
            View Remarks
          </button>
        );
      },
    },
    {
      header: "Created At",
      accessorKey: "created",
      cell: ({ row, getValue }: any) => (
        <div onClick={(event) => {}} role="button" tabIndex={-1}>
          <p>{moment(getValue()).format("YYYY-MM-DD HH:mm")}</p>
        </div>
      ),
    },
    {
      header: "Action",
      accessorKey: "id",
      cell: ({ row, getValue }: any) => {
        return (
          <div className={tw`flex items-center justify-around`}>
            <AccessControl
              children={
                <p className={tw`uppercase flex items-center justify-center`}>
                  <TableActionButton
                    editPath={`/blog/post/edit/${getValue()}`}
                  />
                </p>
              }
              allowedPermissions={["can_update_blogs"]}
            />
            <AccessControl
              children={
                <p className={tw`uppercase w-5 h-5`}>
                  <TableDeleteButton
                    onClick={() => handleDelete(getValue())}
                    disabled={isLoading}
                  />
                </p>
              }
              allowedPermissions={["can_delete_blogs"]}
            />
          </div>
        );
      },
    },
  ];

  return (
    <>
      <DataTable
        url={APIS.BLOG_STATUS}
        queryKey={"posts"}
        columns={defaultColumns}
        addNewPagePath={"/blog/post/create"}
        tableName={"Posts"}
        params={{}}
      />
      <Modal
        isOpen={openDeleteModal}
        setIsOpen={setOpenDeleteModal}
        title={"Delete Post"}
        onClose={handleModalClose}
        showTitle={false}
      >
        <div className={tw`space-y-3 w-fit`}>
          <h2 className={tw`text-xl font-bold`}>Are you sure?</h2>
          <div className={tw`flex items-center gap-5 justify-end`}>
            <button
              className={tw`bg-gray-200 rounded-lg px-2 py-2 focus:outline-none`}
              onClick={handleModalClose}
            >
              Cancel
            </button>
            <button
              onClick={deletePost}
              className={tw`px-2 py-2 rounded-lg bg-red-600  text-white disabled:bg-red-300`}
              disabled={isLoading}
            >
              <p>Delete</p>
            </button>
          </div>
        </div>
      </Modal>
      <Modal
        isOpen={showRemarksModal}
        setIsOpen={setShowRemarksModal}
        onClose={handleRemarksModalClose}
      >
        <div className={tw`w-[600px]`}>
          <Remark selected={selectedRemark} />
        </div>
      </Modal>
    </>
  );
};

export default PostList;
